import { ContentfulContext } from '@/utils/context';
import { useContext, useEffect, useState } from 'react';
import {
  Container,
  Logo,
  InfoContainer,
  Title,
  AmountTitle,
} from './JobCategoryCard.style';
import {
  CONTENTFUL_ARTICLES_ID,
  CONTENTFUL_CATEGORIES_ID,
} from '@/utils/constants';
import { SmallLoader } from '@/components/Loader/Loader.styles';
import Link from 'next/link';

interface Category {
  slug: string;
  name: string;
  icon: any;
}

interface IJobCategoryCard {
  category: Category;
  activeCategorySlug: string;
}

const JobCategoryCard = ({
  category,
  activeCategorySlug,
}: IJobCategoryCard) => {
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const client = useContext(ContentfulContext);
  const { slug, name, icon } = category;
  const active = activeCategorySlug === slug;
  const {
    url,
    details: {
      image: { width, height },
    },
  } = icon?.fields?.file;

  useEffect(() => {
    client
      .getEntries({
        content_type: CONTENTFUL_ARTICLES_ID,
        limit: 0,
        'fields.category.fields.slug': slug,
        'fields.category.sys.contentType.sys.id': CONTENTFUL_CATEGORIES_ID,
      })
      .then((res: any) => {
        setAmount(res.total);
        setLoading(false);
      });
  }, [slug, client]);

  return (
    <Link href={active ? `/blog` : `/blog?category=${slug}`} passHref>
      <Container active={active}>
        <Logo>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={url}
            alt="category-icon"
            width={`${width}px`}
            height={`${height}px`}
            loading="lazy"
          />
        </Logo>
        <InfoContainer>
          <Title>{name}</Title>
          {loading ? (
            <SmallLoader />
          ) : (
            <AmountTitle>
              {amount + (amount === 1 ? ` post` : ` posts`)}
            </AmountTitle>
          )}
        </InfoContainer>
      </Container>
    </Link>
  );
};

export default JobCategoryCard;
